// extracted by mini-css-extract-plugin
module.exports = {"imageSection":"styles_imageSection__4rkmY","image":"styles_image__Xjlfs","imageHolder":"styles_imageHolder__5tzAj","textHolder":"styles_textHolder__pgvNn"};